export const SET_RATE_LIMITS_BY_USER = 'SET_RATE_LIMITS_BY_USER';